var _rect, _mask, _path, _mask2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtrActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 54,
    viewBox: "0 0 100 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 54,
    rx: 8,
    fill: "#E7F0FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_472_22793",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 34.5L50 27L42.5 19.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 27L50.7071 26.2929L51.4142 27L50.7071 27.7071L50 27ZM41.7929 33.7929L49.2929 26.2929L50.7071 27.7071L43.2071 35.2071L41.7929 33.7929ZM49.2929 27.7071L41.7929 20.2071L43.2071 18.7929L50.7071 26.2929L49.2929 27.7071Z",
    fill: "#116DFF",
    mask: "url(#path-2-inside-1_472_22793)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_472_22793",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 34.5L57.5 27L50 19.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 27L58.2071 26.2929L58.9142 27L58.2071 27.7071L57.5 27ZM49.2929 33.7929L56.7929 26.2929L58.2071 27.7071L50.7071 35.2071L49.2929 33.7929ZM56.7929 27.7071L49.2929 20.2071L50.7071 18.7929L58.2071 26.2929L56.7929 27.7071Z",
    fill: "#116DFF",
    mask: "url(#path-4-inside-2_472_22793)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtrActive);
export default __webpack_public_path__ + "static/media/ltr_active.933ad8d9f7a37456185d803cea081618.svg";
export { ForwardRef as ReactComponent };